
import { Navigate, useLocation } from "react-router-dom";
import { Auth } from "../../auth"; 
import { StaticRoutes } from "../../pages/routes"; 

export default function RequireAuth({ children }) {
  const { isLoggedIn, isAuthLoading } = Auth.useContainer();
  const location = useLocation();

  if (isAuthLoading) {
    return null;
  }
  if (!isLoggedIn) {
    return (
      <Navigate to={StaticRoutes.Login} state={{ from: location }} replace />
    );
  }
  return children;
}
